export var sliders = {
  init: function init() {
    require('./product-selected');
    require('./product-selected-system');
    require('./popular-products');
    require('./system-slider-part');
    require('./system-slider');
    require('./system-bundle-slider');
    require('./compare-product');
    require('./usp');
    require('./row-slider');
    require('./promo-slider');
    require('./system-filter');
    require('./system-bundle');
    require('./complete-system');
    require('./shop-more');
    require('./interstellar/hero');
    require('./interstellar/premium-content');
    require('./interstellar/triple-small-slider');
    require('./interstellar/mega-slider');
    require('./interstellar/full-image-with-slider');

    // IOS 13.1.3 Flickity Fix
    var touchingCarousel = false;
    var touchStartCoords;
    document.body.addEventListener('touchstart', function (e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }
      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      };
    });
    document.body.addEventListener('touchmove', function (e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }
      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };
      if (Math.abs(moveVector.x) > 7) e.preventDefault();
    }, {
      passive: false
    });
  }
};


// WEBPACK FOOTER //
// ./scripts/components/sliders/index.js